export const window_open = (
  url?: string | URL | undefined,
  target?: string | undefined,
  features?: string | undefined
) => {
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('openNewTabHandler', { url });
    return null;
  }
  return window.open(url, target, features);
};

export const open_map = (
  url?: string | URL | undefined,
  target?: string | undefined,
  features?: string | undefined
) => {
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('openMapsHandler', { url });
    return null;
  }
  return window.open(url, target, features);
};
